<script>
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwEmail from '@/components/generic/forms/tw-email.vue'
import { useFundraiserSubscriberStore } from '@/stores/fundraiserSubscriber.js'

export default {
  name: "FundraiserSubscribeToUpdatesModal",
  components: { TwEmail, TwValidationErrors, TwInput, TwModal },
  mixins:[modalCascadeMixin],
  props: {
    subscribable: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Loading: false,
      ValidationErrorMessage: null,
      Name: null,
      Email: null
    }
  },
  computed: {
    validEmail() {
      return this.Email && this.Email.includes('@') && this.Email.includes('.')
    }
  },
  methods: {
    async subscribeToFundraiser() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        await useFundraiserSubscriberStore().itemCreate({
          subscribable_id: this.subscribable.id,
          subscribable_type: this.subscribable.object_type,
          name: this.Name,
          email: this.Email
        })
        this.Loading = false
        this.close()
        this.$notify(`<p class="mb-2">Thank you for subscribing to our <strong>${this.subscribable.title}</strong> fundraiser.</p><p> You will receive an email when there are updates.</p>`)
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" :ok-disabled="!validEmail" :loading="Loading" ok-text="Subscribe to updates" :title="'Subscribe to receive updates for ' + subscribable.title" @ok="subscribeToFundraiser">
    <div class="grid sm:grid-cols-2 gap-2 md:gap-4">
      <div> <tw-input v-model="Name" label="Name:" /> </div>
      <div> <tw-email v-model="Email" label="Email:" /> </div>
    </div>
    <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
  </tw-modal>
</template>

<style scoped>

</style>
